export default {"src":"/_next/static/media/technical-error.61768b21.svg","height":347,"width":536,"blurWidth":0,"blurHeight":0};